// import { authHeader } from './auth-header';
import Api from "./PreApiHandler";

export default {
    getBotEvents,
    getEventNames,
    useReportTemplate,
    exportCsvReport,
    getFunnelStepUsers,
    sqlToJson,
    getDataSql
};

async function getBotEvents(params = {}) {
    const request = {
        method: 'get',
        path: 'report/builder/get-bot-events',
        params
    }
    return Api.sendRequest(request)
}

async function getEventNames() {
    return Api.sendRequest({ method: 'get', path: 'report/builder/get-event-names' })
}

async function useReportTemplate(params = {}, body, { suppressAccessDenied = false, signal = null } = {}) {
    const request = {
        method: 'post',
        path: 'report/builder/use-report-template',
        params,
        body,
        suppressAccessDenied,
        signal
    }
    return Api.sendRequest(request)
}

async function exportCsvReport(params = {}, body) {
    const request = {
        method: 'post',
        path: 'report/builder/export-csv',
        params,
        body,
        options: { blob: true, filename: 'report.csv' }
    }
    return Api.sendRequest(request)
}

async function getFunnelStepUsers(params = {}, body) {
    const request = {
        method: 'post',
        path: 'report/builder/funnel-step-users',
        params,
        body
    }
    return Api.sendRequest(request)
}

// SQL mode: dry-run — transpile SQL to JSON + validate, no execution
async function sqlToJson(body) {
    return Api.sendRequest({
        method: 'post',
        path: 'report/builder/sql-to-json',
        body
    })
}

// SQL mode: transpile + execute in ClickHouse
async function getDataSql(body, { suppressAccessDenied = false, signal = null } = {}) {
    return Api.sendRequest({
        method: 'post',
        path: 'report/builder/get-data-sql',
        body,
        suppressAccessDenied,
        signal
    })
}